<template>
	<div class="imageGallery">
		<img :src="require(`@/assets/images/imageGallery/bg-players.jpg`)" alt="">
	</div>
	<!-- <PricingModal
	  :monthlyPrice="pricingInfo ? pricingInfo.monthlyPaymentInstallment : 0"
	/> -->
	<VRModal
	  v-if="availableSeatViews"
	  :availableSeatViews="availableSeatViews"
	/>
	<div class="seating_pricing" id="seating_pricing">
		<div class="section-header">
			<img :src="require(`@/assets/images/${usbLogo}`)" alt="">
			<SectionHeader topText="SEATING &amp; Pricing" middleText=""  textColor="white" textAlign="center"/>
		</div>
		<div class="map-container">
			<div class="seating-img_chart img_container">

			  <SeatingChart id="locationsMap" @callback="(sectionId) => newSectionSelected(sectionId)"  />

			</div>
			<p>Prices ranging from $50 - $175 per game</p>
			<button class="priority-button" v-b-modal.vr-modal v-if="sectionSelected && availableSeatViews" >
			  OPEN 3D SEAT VIEW
			</button>
			
		</div>


	</div>

</template>
<script>

import { reactive, toRefs, computed, watch, ref } from "vue";
import { useStore } from "vuex";
import SeatingChart from "./SeatingChart";
// import priceSection from "./priceSection";
import SectionHeader from "@/components/SectionHeader";

// import Dropdown from "./Dropdown";
// import PricingModal from "./PricingModal";

import VRModal from "./VRModal";
import mapData from "@/data/mapData";
// import priceData from "@/data/priceData";

export default {
  name: "seatingPriceChart",
  components: {
	  SectionHeader,
	  SeatingChart,
	  VRModal,
  },
  //emit: ["upgradeShow"],
  data() {
	  return {
		sectionSelected: null,
		availableSeatViews: null,

	  };
	},
  setup() {
    const store = useStore();
    // State
    const state = reactive({
		  seatingChart: computed(() =>
		  	"Full-Map.svg"
	  	  ),
		  bgSrc: computed(() =>
		  	"bg-pricing.jpg"
	  	  ),
		  usbLogo: computed(() =>
		  	"ubs-logo.svg"
	  	  ),
    });
    return { ...toRefs(state), store };
	//
  },
  mounted() {
	  this.sectionSelected = ["305"];
	  this.newSectionSelected(this.sectionSelected);
  },
  methods: {

	newSectionSelected(sectionId) {
      if (sectionId != "Front-Row") {
        this.availableSeatViews = mapData["section" + sectionId];
        this.sectionSelected = sectionId;
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.imageGallery{
	img{
		height: 463px;
		width:100%;
		object-fit: cover;
		object-position: center;
		@include media-breakpoint-down(sm) {
			height: 263px;
		}
	}

}
.seating_pricing{
	background-color: theme-var($--ch-theme-primary);
	background-repeat: no-repeat;
	background-size: cover;
	display:flex;
	flex-direction:column;
	justify-content: center;
	align-items:center;
	padding: 50px 0px;
	@include media-breakpoint-down(sm) {
		background-position:right;
		flex-direction: column-reverse;
	}
	@media only screen and (min-width: 578px) and (max-width: 900px)  {
		// background-position:right;
		flex-direction: column-reverse;
	}
	.section-header{
		display:flex;
		flex-direction: column;
		justify-content: center;
		align-items:center;
		padding:30px 0px;
		img{
			max-height:34px;
			height:auto;
			width:auto;
		}
		@include media-breakpoint-down(sm) {
			display:flex;
			flex-direction: column;
			justify-content: center;
			align-items:center;
		}
		@media only screen and (min-width: 578px) and (max-width: 900px)  {
			display:flex;
			flex-direction: column;
			justify-content: center;
			align-items:center;
		}

	}
	p{
		padding:30px 0px 0px 0px;
		font-family: "GeogrotesqueSharp-Md";
		font-size: 21px;
		color: #FFFFFF;
		letter-spacing: 0;
		text-align: center;
		font-weight: 500;
		@include media-breakpoint-down(sm) {
			text-align:center;
			font-size: 12px;
		}
	}

	.map-container{

		flex-grow: 1;
		flex-basis: 150px;
		display:flex;
		justify-content: center;
		align-items:center;
		flex-direction: column;
		// padding:30px 0;
		@include media-breakpoint-down(sm) {
			justify-content: center;
		}
		@media only screen and (min-width: 578px) and (max-width: 900px)  {
			justify-content: center;
		}
		button{
			text-transform:uppercase;
			margin: 20px auto;
			width: 200px;
			text-decoration:none;
			display: flex;
	        justify-content: center;
	        align-items: center;
			height: 40px;
			background-color: theme-var($--ch-theme-secondary);
			border: none;
			padding:20px;
			color: white;
			font-family: "GeogrotesqueSharp-Md";
			font-size: 18px;
			letter-spacing: 0;
			text-align: center;
			font-weight: 500;
			transition: all .25s ease-in-out;
			&:hover{
				background:theme-var($--ch-theme-on-primary);
				// border: 1px solid #1D1D1D;
				color: theme-var($--ch-theme-on-secondary) !important;
			}
			@include media-breakpoint-down(sm) {
				margin: 40px auto;
			}
		}

	}
}
@media only screen and (min-width: 578px) and (max-width: 900px) {}

</style>
